<template>
  <div class="inner-wrapper">
    <div class="game-grid gameboard" ref="gameboard">
      <div class="line"></div>
      <div>
        <img src="../assets/images/years/1451.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="1">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img01" :target="6" />
      </div>

      <div>
        <img src="../assets/images/years/1488.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="2">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img02" :target="4" />
      </div>

      <div>
        <img src="../assets/images/years/1470.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="3">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img03" :target="1" />
      </div>

      <div>
        <img src="../assets/images/years/1466.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="4">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <!-- <img src="../assets/images/dropzone_2.png" alt="" /> -->

        <Draggable :active="active" :image="img04" :target="7" />
      </div>

      <div>
        <img src="../assets/images/years/1463.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="5">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img08" :target="2" />
      </div>

      <div>
        <img src="../assets/images/years/1475.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="6">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img05" :target="8" />
      </div>

      <div>
        <img src="../assets/images/years/1457.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="7">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img06" :target="3" />
      </div>

      <div>
        <img src="../assets/images/years/1465.png" alt="" />
      </div>
      <div>
        <Droppable @add-point="addPoint()" :target="8">
          <img src="../assets/images/dropzone_2.png" alt="" />
        </Droppable>
      </div>
      <div>
        <img src="../assets/images/arrow.png" alt="" />
      </div>
      <div>
        <Draggable :active="active" :image="img07" :target="5" />
      </div>
    </div>
  </div>
</template>
<script setup>
import Draggable from './Draggable.vue'
import Droppable from './Droppable.vue'

import { ref, onMounted, watch } from 'vue'

const points = ref(0)

const gameboard = ref(null)

const props = defineProps(['active'])

const emit = defineEmits(['win'])

import img01 from '../assets/images/items/image_1.png'
import img02 from '../assets/images/items/image_2.png'
import img03 from '../assets/images/items/image_3.png'
import img04 from '../assets/images/items/image_4.png'
import img05 from '../assets/images/items/image_5.png'
import img06 from '../assets/images/items/image_6.png'
import img07 from '../assets/images/items/image_7.png'
import img08 from '../assets/images/items/image_8.png'

const addPoint = () => {
  points.value += 1
}

watch(points, (o) => {
  if (o == 8) {
    emit('win')
  }
})
</script>
<style lang=""></style>
